import { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Alert, Card, Col, Container, Row, Spinner } from 'react-bootstrap'
import { Link, useSearchParams } from 'react-router-dom'
import classnames from 'classnames'

import HeaderOutside from 'components/layout/headerOutside'
import Footer from 'components/layout/footer'
import loginCss from '../signIn/styles.module.scss'
import * as userApi from '../api.client'
import { completeLogin, LoginRoleNotAllowedError } from '../completeLogin'
import { UserRole } from '../types'

export const ExternalAuth: FunctionComponent<{
  handleSuccessfulLogin: () => void
}> = ({ handleSuccessfulLogin }) => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const authenticatingRef = useRef(false)

  useEffect(() => {
    const accessToken = searchParams.get('access_token')

    if (!accessToken) {
      setError('Token de acesso não encontrado.')
      return
    }

    if (authenticatingRef.current) {
      return
    }

    authenticatingRef.current = true

    const authenticate = async () => {
      try {
        const jwt = await userApi.authenticateWithExternalToken(accessToken)
        await completeLogin(jwt, handleSuccessfulLogin, {
          allowedRoles: [UserRole.DOCTOR],
        })
      } catch (err) {
        console.error(err)
        setError(
          err instanceof LoginRoleNotAllowedError
            ? err.message
            : 'Não foi possível autenticar. O token pode estar expirado ou inválido.'
        )
        authenticatingRef.current = false
      }
    }

    authenticate()
  }, [searchParams, handleSuccessfulLogin])

  return (
    <div>
      <HeaderOutside />

      <Container fluid className={loginCss.container}>
        <Row className={classnames('justify-content-md-center', loginCss.row)}>
          <Col md="3" className={loginCss.col}>
            <Card className={classnames('mb-2', loginCss.card)}>
              <Card.Body>
                <h5 className={loginCss.title}>Acessar o Clic-repasse</h5>

                {error ? (
                  <>
                    <Alert variant="danger">{error}</Alert>
                    <Link to="/login">Ir para o login</Link>
                  </>
                ) : (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3 mb-0">Autenticando...</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </Container>
    </div>
  )
}

export default ExternalAuth
